import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["table"]

  connect() {
    this.element.addEventListener("turbo:before-fetch-response", this.handleResponse.bind(this))
  }

  handleResponse(event) {
    const response = event.detail.fetchResponse
    if (response.succeeded) {
      // Force a refresh of the table after successful deletion
      this.tableTarget.innerHTML = response.responseText
    }
  }
} 